module.exports = __webpack_public_path__ + "static/img/big-icon-2.59e3df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/big-icon-2.png
// module id = tOZM
// module chunks = 85